import axios from 'axios';

const getApiUrl = () => {
  const hostname = window.location.hostname;
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:3000';
  }
  // Production: API is proxied through Nginx on the same domain
  return `https://${hostname}/api`;
};

// const getApiBaseUrl = () => {
//   const hostname = window.location.hostname;
  
//   if (hostname === 'localhost' || hostname === '127.0.0.1') {
//     // Local development
//     return 'http://localhost:3000';
//   } else if (hostname === '10.0.0.28') {
//     // Local network access
//     return 'http://10.0.0.28:3000';
//   } else {
//     // Remote access - use same hostname as frontend but port 3000
//     return `http://${hostname}:3000`;
//   }
// };

const API_BASE_URL = getApiUrl();

console.log('API Base URL:', API_BASE_URL); // Debug log

const api = axios.create({
  baseURL: API_BASE_URL,
});

// Add auth token to requests if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const apiService = {
  // Players
  getPlayers: () => api.get('/players'),
  createPlayer: (data) => api.post('/players', data),
  
  // Events
  getEvents: () => api.get('/events'),
  createEvent: (data) => api.post('/events', data),
  
  // Tournaments
  getTournaments: () => api.get('/tournaments'),
  getTournament: (id) => api.get(`/tournaments/${id}`),
  createTournament: (data) => api.post('/tournaments', data),
    getTournamentClock: (id) => {
    console.log('API Service - getTournamentClock called with id:', id);
    const url = `/tournaments/${id}/clock`;
    console.log('API Service - calling URL:', url);
    return api.get(url);
  },
  getTournamentStructure: (id) => api.get(`/tournaments/${id}/structure`),
  
  // Authentication
  adminLogin: (credentials) => api.post('/admin/login', credentials),
  verifyPin: (data) => api.post('/admin/verify-pin', data),
  dealerAuth: (dealerCode) => api.post('/dealer/auth', { dealer_code: dealerCode }),
};

// Add request interceptor to log outgoing requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  
  // Log the request
  console.log('=== API REQUEST ===');
  console.log('URL:', config.baseURL + config.url);
  console.log('Method:', config.method);
  console.log('Full config:', config);
  
  return config;
});

// Add response interceptor to log responses
api.interceptors.response.use(
  (response) => {
    console.log('=== API RESPONSE RECEIVED ===');
    console.log('URL:', response.config.url);
    console.log('Status:', response.status);
    console.log('Response headers:', response.headers);
    console.log('Response data type:', typeof response.data);
    console.log('Response data keys:', response.data ? Object.keys(response.data) : 'no data');
    console.log('Full response data:', response.data);
    console.log('Specific fields in response:');
    if (response.data) {
      console.log('- total_entries:', response.data.total_entries);
      console.log('- total_prize_pool:', response.data.total_prize_pool);
      console.log('- tournament_start_time:', response.data.tournament_start_time);
      console.log('- players_remaining:', response.data.players_remaining);
    }
    return response;
  },
  (error) => {
    console.error('=== API ERROR ===');
    console.error('URL:', error.config?.url);
    console.error('Error:', error);
    return Promise.reject(error);
  }
);

export { API_BASE_URL };
